import { isStreamIQ, isToya } from '@/shared/lib'

export const getConfigRepository = async () => {
    if (isToya()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/toya/config/repository/configRepositoryToya')
            return module.ConfigRepositoryToya
        } catch (error) {
            console.warn(
                'ConfigRepositoryToya module is missing. TOYA-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/shared/classes/ConfigRepositoryStreamIQ')
            return module.ConfigRepositoryStreamIQ
        } catch (error) {
            console.warn(
                'ConfigRepositoryStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
